import { Tab, Tabs } from "@mui/material";

interface Props {
  currentTab: string;
  onSetCurrentTab: (tab: string) => void;
}

export const BridgeTabs = ({ currentTab, onSetCurrentTab }: Props) => {
  return (
    <Tabs
      value={currentTab}
      onChange={(_, value) => onSetCurrentTab(value)}
      sx={{
        width: "100%",
        ".MuiTabs-flexContainer": {
          gap: 6,
          justifyContent: "space-between",
          width: "100%",
        },
      }}
    >
      <Tab
        sx={{ typography: "h3" }}
        label="Bridge"
        value="deposit"
        disableRipple
      />

      <Tab
        label="History"
        value="history"
        disableRipple
        sx={{ typography: "h3" }}
      />
    </Tabs>
  );
};
